import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React, { useCallback, useEffect, useRef, useState } from 'react';

var EasTabs = function EasTabs(_ref) {
  var _context, _context3;

  var tabControl = _ref.tabControl,
      className = _ref.className,
      tabbarClassName = _ref.tabbarClassName,
      tabbarItemActiveClassName = _ref.tabbarItemActiveClassName,
      tabbarItemClassName = _ref.tabbarItemClassName,
      hideTabText = _ref.hideTabText,
      children = _ref.children,
      scrollToTop = _ref.scrollToTop,
      animation = _ref.animation;
  var loading = useRef(false);
  var container = useRef(null);

  var _tabControl = _slicedToArray(tabControl, 2),
      tab = _tabControl[0],
      setTab = _tabControl[1];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      rendered = _useState2[0],
      setRendered = _useState2[1];

  var click = function click(i) {
    if (loading.current) return;
    if (scrollToTop) document.body.scrollTop = 0;
    setTab(i);
  };

  useEffect(function () {
    if (!rendered) {
      setRendered(true);
    }
  }, [rendered]); //获取tab切换，锁定click事件

  useEffect(function () {
    if (!tab || !rendered) return;
    loading.current = true;
    setTimeout(function () {
      loading.current = false;
    }, 400);
  }, [rendered, tab]);
  var getWidth = useCallback(function () {
    var _container$current;

    return ((_container$current = container.current) === null || _container$current === void 0 ? void 0 : _container$current.clientWidth) || 0;
  }, []);
  return React.createElement("div", {
    className: className ? "eas__tabs ".concat(className) : 'eas__tabs',
    ref: container
  }, React.createElement("div", {
    className: tabbarClassName
  }, _mapInstanceProperty(_context = React.Children).call(_context, children, function (child, index) {
    var _context2;

    var title = child.props.title;
    if (!title || typeof title !== 'string') throw new Error('invalid tab title');
    return React.createElement("div", {
      className: tab === index + 1 ? _concatInstanceProperty(_context2 = "".concat(tabbarItemClassName, " ")).call(_context2, tabbarItemActiveClassName) : tabbarItemClassName,
      key: title,
      onClick: function onClick() {
        return click(index + 1);
      }
    }, !hideTabText && title);
  })), React.createElement("div", {
    className: "tabs__container",
    style: {
      transition: animation === false ? 'none' : 'transform 0.3s ease-in-out',
      transform: "translate(".concat(-getWidth() * (tab - 1), "px,0px)")
    }
  }, _mapInstanceProperty(_context3 = React.Children).call(_context3, children, function (child, index) {
    var item = _objectSpread(_objectSpread({}, child), {}, {
      props: _objectSpread(_objectSpread({}, child.props), {}, {
        current: tab,
        index: index + 1,
        animation: animation
      })
    });

    return item;
  })));
};

export default React.memo(EasTabs, function (prev, next) {
  if (prev.children !== next.children) return false;
  return prev.tabControl[0] === next.tabControl[0];
});